module.exports = require('./BreadcrumbView');
